module.exports = require('./BreadcrumbView');
